// Domain 04 — WAN Technologies (RouteZero Batangas Regional WAN Hub, Batangas City)
import u01 from './u01-wan-fundamentals.js';
import u02 from './u02-wan-topologies.js';
import u03 from './u03-point-to-point.js';
import u04 from './u04-wan-edge.js';
import u05 from './u05-wan-redundancy.js';
import u06 from './u06-wan-outage.js';
import u07 from './u07-qos-fundamentals.js';
import u08 from './u08-qos-marking.js';
import u09 from './u09-qos-troubleshooting.js';
import u10 from './u10-vpn-fundamentals.js';
import u11 from './u11-site-to-site-vpn.js';
import u12 from './u12-vpn-troubleshooting.js';
import u13 from './u13-wan-operations.js';
import u14 from './u14-final.js';

export default {
  id: 'd04', number: '04', title: 'WAN Technologies',
  tagline: 'Point-to-point circuits, the WAN edge, redundant paths, QoS for voice and IPsec site-to-site VPNs across RouteZero\'s Batangas regional WAN.',
  units: [u01, u02, u03, u04, u05, u06, u07, u08, u09, u10, u11, u12, u13, u14],
};
